// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

import {Side} from 'constants/MolbioConstants';
import Type from 'molbio/maps/Type';

interface RangeAttributes {
  start: number;
  end: number;
  maxWidth: number;
  active: boolean;
  panning: boolean;
  dragging: boolean;
  freeEnd: Side;
  type: Type;
  // Only set in a few contexts.
  getLengthFn: () => number;
  // Seemingly unused.
  sequence: unknown;
}

interface Range {
  get<K extends keyof RangeAttributes>(key: K): RangeAttributes[K];
  set<K extends keyof RangeAttributes>(
    attributeName: K,
    value: RangeAttributes[K],
    options?: Backbone.ModelSetOptions
  ): Range;
  set(obj: Partial<RangeAttributes>): Range;
}

/**
 * A Range object specifies a set of endpoints similar to a Selection, but should generally always be
 * fully specified, while a Selection may only be a single point when empty. It is used for tracking
 * which portion of a sequence map is viewed for maps like the Mini (AKA "Linear") Map and alignments.
 */
class Range extends Backbone.Model {
  static initClass(): void {
    this.prototype.defaults = {
      // @ts-expect-error
      maxWidth: null,
      getLengthFn() {
        throw new Error('getLength not specified');
      },
      sequence: null,
      start: null,
      end: null,
      active: false,
      panning: false,
      freeEnd: null, // 'start', 'end'
      type: null,
    };
  }

  getLength(): number {
    return this.get('getLengthFn')();
  }

  freeEnd(): Side {
    return this.get('freeEnd');
  }

  anchorEnd(): Side {
    if (this.get('freeEnd') === 'start') {
      return 'end';
    } else {
      return 'start';
    }
  }

  span(): number {
    return this.end() - this.start();
  }

  preview(): Range {
    return this.clone() as Range;
  }

  start(): number {
    return this.get('start');
  }
  end(): number {
    return this.get('end');
  }

  panStart(start: number): void {
    const length = this.getLength();
    const span = this.span();
    start = Math.min(length - span, Math.max(0, start));
    this.set({start, end: start + this.span()});
    this.trigger('rangeChange', false, true);
  }

  pan(middle: number): void {
    const span = this.span();
    this.panStart(Math.floor(middle - span / 2));
  }

  setStart(index: number): void {
    this.set('start', index);
    this.set('freeEnd', 'start');
  }

  setEnd(index: number): void {
    this.set('end', index);
    this.set('freeEnd', 'end');
  }

  extend(index: number): void {
    const vals: {start: number; end: number; freeEnd?: Side} = {start: this.start(), end: this.end()};

    vals[this.freeEnd()] = index;

    if (vals.start === vals.end) {
      vals[this.freeEnd()] = index + 1;
    }

    // Swap if they switch places.
    if (vals.start > vals.end) {
      [vals.start, vals.end] = [vals.end, vals.start];
      vals.freeEnd = this.anchorEnd();
    }

    this.set(vals);
  }

  correct(): Range {
    let newEnd: number;
    let newStart: number;
    let realSpan: number;

    const width = this.get('maxWidth');
    const span = Math.max(2, this.span());
    const length = this.getLength();
    const type = Type.typeToFitWidth(span, width);
    if (type.manual) {
      type.setHeight(10);
      this.set('type', type);
      realSpan = Math.floor(span);
    } else {
      const largestSpan = Type.largest.numChars(width);
      const normalSpan = type.numChars(width);
      if (largestSpan > normalSpan) {
        this.set('type', Type.largest);
        realSpan = largestSpan;
      } else {
        this.set('type', type);
        realSpan = normalSpan;
      }
    }
    const curStart = this.start();
    const curEnd = this.end();
    if (this.get('freeEnd') === 'end') {
      newStart = curStart;
      newEnd = curStart + realSpan;
      if (newEnd > length) {
        newEnd = length;
        newStart = length - realSpan;
      }
    } else {
      newStart = curEnd - realSpan;
      newEnd = curEnd;
      if (newStart < 0) {
        newStart = 0;
        newEnd = realSpan;
      }
    }

    this.set({start: newStart, end: newEnd});
    this.trigger('rangeChange', true, false);
    return this;
  }
}
Range.initClass();

export default Range;
